"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var useWindowSize_1 = require("./useWindowSize");
var breakpoints = {
    xs: 375,
    sm: 544,
    md: 768,
    lg: 992,
    xl: 1200,
};
var useBreakpoint = function () {
    var width = (0, useWindowSize_1.useWindowSize)().width;
    var viewPorts = Object.keys(breakpoints).filter(function (key) { return breakpoints[key] <= width; });
    return viewPorts;
};
exports.useBreakpoint = useBreakpoint;
